window.addEventListener('DOMContentLoaded', (event) => {
  if ((window.location.href.indexOf("es/pricing/quotation-") > -1)) {
    $("#section-1 .desktop .price-label .value").removeClass('value').addClass('h3');
    $("#section-1 .desktop h5.body-small").css('max-width', '170px')
    $("#section-1 .mobile h5.body-small").addClass('mx-auto')
    $("#section-1 .desktop:last-child > h5").after('<span style="height: 40px;"></span>')
    $("#section-1 > .mobile .price-card:last-child .col").css({
      'height': '130px',
      'display': 'flex',
      'align-items': 'flex-end'
    });
  }
  if ((window.location.href.indexOf("es/pricing/quotation-solo") > -1)) {
    $("#section-1 .mobile h3.w-151").hide();
  }
});
